import { Alert, Button, Space } from 'antd';
import React, { ReactElement } from 'react';
import './BlueBgInformativeAlert.less';

const BlueBgInformativeAlert = (props: any): ReactElement => {
  const { onClick, text, okButtonRequired } = props;
  return (<>
    <Space direction="vertical" className="flex-element flex-row items-center justify-center blue-bg-informative-container-space">
      <Alert
        className="blue-bg-informative-alert"
        message={<>
          <div className="flex-element flex-row items-center justify-center gap-2">
            <div>
            {text}
            </div>
            {
              okButtonRequired &&
              <Button size="middle" type="primary" onClick={(): any => onClick()} >
                OK
              </Button>
            }
          </div>
          </>
        }
        closable={false}
      />
    </Space>
  </>);
};
export default BlueBgInformativeAlert;
